import React from "react";
import { Navigate } from "react-router-dom";

import { ADD_CCF_POINT_URL, DASHBOARD_URL, EDIT_CCF_POINT_URL, HOME_URL, MANAGE_CCF_POINTS_URL, MANAGE_CLIENT_URL, MANAGE_COMMANDS_URL, MANAGE_COMPLIANCE_URL, MANAGE_FRAMEWORK_URL, MANAGE_LICENSE_URL, MANAGE_PROJECT_URL, NOT_FOUND_URL, NOTIFICATION_URL, SUPPORT_URL, VIEW_CLIENT_URL, VIEW_SUPPORT_URL } from "../constants/urls.js";
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Dashboard from "../pages/Dashboard";
import ManageCCFPoints from "../pages/ManageCertification/ManageCCFPoints";
import AddCCFPoint from "../pages/ManageCertification/ManageCCFPoints/AddCCFPoint.jsx";
import EditCCFPoint from "../pages/ManageCertification/ManageCCFPoints/EditCCFPoint";
import ManageCompliance from "../pages/ManageCertification/ManageCompliance";
import ManageClients from "../pages/ManageClients";
import ViewClient from "../pages/ManageClients/ViewClient";
import ManageLicense from "../pages/ManageLicense";
import ManageNotifications from "../pages/ManageNotifications";
import ManageProject from '../pages/ManageProject';
import ManageSupport from "../pages/ManageSupport";
import ViewSuport from "../pages/ManageSupport/ViewSuport/index.jsx";
import ManageFramework from "../pages/Dhanush/ManageFramework/index.jsx";
import ManageCommands from "../pages/Dhanush/ManageCommands/index.jsx";

const authProtectedRoutes = [
  { path: DASHBOARD_URL, component: <Dashboard /> },
  { path: HOME_URL, exact: true, component: <Navigate to={DASHBOARD_URL} /> },
  { path: MANAGE_CLIENT_URL, component: <ManageClients /> },
  { path: VIEW_CLIENT_URL, component: <ViewClient /> },
  { path: MANAGE_PROJECT_URL, component: <ManageProject /> },
  { path: MANAGE_COMPLIANCE_URL, component: <ManageCompliance /> },
  { path: MANAGE_CCF_POINTS_URL, component: <ManageCCFPoints /> },
  { path: EDIT_CCF_POINT_URL, component: <EditCCFPoint /> },
  { path: ADD_CCF_POINT_URL, component: <AddCCFPoint /> },
  { path: NOTIFICATION_URL, component: <ManageNotifications /> },
  { path: SUPPORT_URL, component: <ManageSupport /> },
  { path: VIEW_SUPPORT_URL, component: <ViewSuport /> },
  { path: MANAGE_LICENSE_URL, component: <ManageLicense /> },


{ path: MANAGE_FRAMEWORK_URL, component: <ManageFramework /> },
{ path: MANAGE_COMMANDS_URL, component: <ManageCommands /> },
  { path: "*", component: <Navigate to={NOT_FOUND_URL} /> },
];

const publicRoutes = [
  { path: NOT_FOUND_URL, component: <Alt404 /> },
];

export { authProtectedRoutes, publicRoutes };
